module.exports = __webpack_public_path__ + "r-v3/img/cursor_eraser_blue.d41d8cd9.png";